export default "__VITE_ASSET__BzGhOXEE__"